import { query_customer_activation_event_list } from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-customer_activation_event_record-config';

import { reactive } from 'vue';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY);

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'remotemodal',
      name: 'customer_id',
      label: '客户姓名',
      disabled: false,
      placeholder: '请选择客户姓名',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-customer',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    customer_id: null,
  }),
};
const search_options = {};

const edit_model_config = {};
const edit_model_config_options = {};

const update_model_config = {};
const update_model_config_options = {};

const titleList = {
  title: '客户活跃记录表',
  addModalTitle: '新建客户活跃记录表',
  updateTitle: '编辑客户活跃记录表',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    id: 'id',
  },
  delete: {
    id: 'id',
  },
  recover: {
    id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
  },
  {
    title: '客户编号',
    dataIndex: '_record__customer__code',
    width: 130,
  },
  {
    title: '客户名称',
    width: 120,
    dataIndex: '_record__customer__name',
    checked: true,
  },
  {
    title: '会籍门店',
    dataIndex: '_record__customer__shop__name',
    width: 130,
  },
  {
    title: '所属顾问',
    width: 120,
    dataIndex: '_record__customer__adviser__name',
    checked: true,
  },
  {
    title: '活动时间',
    width: 150,
    dataIndex: 'datetime',
    checked: true,
  },
  {
    title: '活动内容',
    width: 260,
    dataIndex: 'content',
    content: (record: any, text: any) => {
      let value = '';
      if (record.type == 'cz_record') {
        value = '门店:' + record.record.shop__name + ',充值' + record.record.price;
      } else if (record.type == 'order_used_record') {
        value = '门店:' + record.record.shop__name + ',耗单' + record.record.project__name;
      }
      return value;
    },
    checked: true,
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
// newSlotList.push({
//   type: 'custom',
//   // slotName: 'is_active',
//   field_true: '可用',
//   field_false: '作废',
// });

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_customer_activation_event_list,
    addData: null,
    updateData: null,
    removeData: null,
    recoverData: null,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
    rowKey: '_index',
    init_request: false,
  };
};
